import { OrderStatus, PaymentTerms } from '../../../types/api/order'
import { ItemStatus, OrderItemUnit } from '../../../types/api/order-item'

export const orderStatusLabels: Record<OrderStatus, string> = {
    draft: 'Черновик',
    awaitingApproval: 'Ожидает согласования',
    confirmed: 'Подтверждён',
    inProduction: 'В производстве',
    partiallyShipped: 'Частично отгружен',
    shipped: 'Отгружен',
    closed: 'Закрыт',
    cancelled: 'Отменён',
}

export const paymentTermsLabels: Record<PaymentTerms, string> = {
    prepayment: 'Предоплата',
    postPayment: 'Постоплата',
    deferral: 'Отсрочка',
}

export const orderItemUnitLabels: Record<OrderItemUnit, string> = {
    pcs: 'шт',
    m: 'м',
    m2: 'м²',
    kg: 'кг',
    set: 'комплект',
    km: 'км',
    roll: 'рулон',
}

export const itemStatusLabels: Record<ItemStatus, string> = {
    draft: 'Черновик',
    calculated: 'Рассчитана',
    approved: 'Согласована',
    inProduction: 'В производстве',
    shipped: 'Отгружена',
}

export const orderStatusOptions = (Object.keys(orderStatusLabels) as OrderStatus[]).map(value => ({
    value,
    label: orderStatusLabels[value],
}))

export const paymentTermsOptions = (Object.keys(paymentTermsLabels) as PaymentTerms[]).map(
    value => ({
        value,
        label: paymentTermsLabels[value],
    })
)
